export default __webpack_public_path__ + "static/media/bewerber-section-houses.a461d6e9.png";